import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import PowerGrid from './PowerGrid';
import PowerStatusMessage from './PowerStatusMessage';

function PowerDetails(props) {
    const { view, redisCommonData, prescription, prescription: { imageFileName, left, right }, showPowerDetailsFn, showUploadPrescModal, dataLocale } = props;
    const [powerState, setPowerState] = useState({});
    useEffect(() => {
        let section = 'CONTACT_FOR_POWER';
        let icon;
        let message;
        if (left && Object.keys(left).length > 0 && (Object.keys(left).some(itm => itm !== 'boxes' && left[itm] !== '' && left[itm] !== null && !isNaN(left[itm])))) {
            section = 'POWER_GRID';
        } else if (right && Object.keys(right).length > 0 && (Object.keys(right).some(itm => itm !== 'boxes' && right[itm] !== '' && right[itm] !== null && !isNaN(right[itm])))) {
            section = 'POWER_GRID';
        } else if (imageFileName) {
            section = 'POWER_UPLOAD';
        } else if (left && Object.keys(left).length > 0 && ('ap' in left) && (left.ap !== 'Call Me/Email Me for Power')) {
            section = 'POWER_GRID';
        } else if (right && Object.keys(right).length > 0 && ('ap' in right) && (right.ap !== 'Call Me/Email Me for Power')) {
            section = 'POWER_GRID';
        }
        if (typeof showPowerDetailsFn === 'function') showPowerDetailsFn(section);
        if (['POWER_UPLOAD', 'CONTACT_FOR_POWER'].includes(section)) {
            const powerStatusMessage = redisCommonData?.POWER_STATUS_MESSAGE && JSON.parse(redisCommonData.POWER_STATUS_MESSAGE);
            if (section === 'POWER_UPLOAD') {
                icon = powerStatusMessage?.powerUploadText.icon || 'https://static.lenskart.com/media/mobile/universal/assets/power-upload.svg';
                message = powerStatusMessage?.powerUploadText.message || dataLocale?.PRESCRIPTION_UPLOADED_WILL_ASSIST_YOU;
            } else {
                icon = powerStatusMessage?.dontKnowPowerText.icon || 'https://static.lenskart.com/media/mobile/universal/assets/dont-know-power.svg';
                message = powerStatusMessage?.dontKnowPowerText.message || dataLocale?.DONT_KNOW_PRESCRIPTION_WILL_ASSIST_YOU;
            }
        }
        setPowerState({ section, icon, message });
    }, []);

    const { section, icon, message } = powerState;
    if (!section) {
        return null;
    }
    return (
        <React.Fragment>
            {{
                POWER_GRID: <PowerGrid prescription={prescription} view={view} dataLocale={dataLocale} />,
                POWER_UPLOAD: <PowerStatusMessage imgIcon={icon} message={message} view={view} showUploadPrescModal={showUploadPrescModal} dataLocale={dataLocale} />,
                CONTACT_FOR_POWER: <PowerStatusMessage imgIcon={icon} message={message} view={view} />
            }[section]}
        </React.Fragment>
    );
}

function mapStateToProps(state) {
    return {
        redisCommonData: state.common.redisCommonData
    };
}

export default connect(mapStateToProps, null)(PowerDetails);
